module.exports = __webpack_public_path__ + "assets/images/project/up-arrow.svg?v=0a17fd54";